import React,{useState} from 'react'
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import { Box, IconButton, Tooltip, } from '@material-ui/core'
import SearchIcon from "@material-ui/icons/Search";
import Reporte from './Reporte'
import ReporteSN from "./ReporteSNDatos";
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns"; 
import esLocale from "date-fns/locale/es";
import {valor} from './Formato-Reporte-Arranque250511'
//import Reloj from './Reloj';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import LinearProgress from '@material-ui/core/LinearProgress';
import {llamaApiCargaToken, ErrorGeneral} from '../funciones/ClienteAxios';
 
const RepoArranque = () => {
  const [datos,setDatos]= useState([])  
  let history = useHistory();
  const source = axios.CancelToken.source();  
  const {usuario,guardarUsuario}=React.useContext(AuthContext);
  const {guardarGenerales}=React.useContext(GeneralesContext);  
  const [espera, setEspera] = useState(false);    
  const [buscar, setBuscar] = useState(true);
  const [fechas,setFechas]=useState({auxFecha:new Date, fechaFin:new Date})
  const {auxFecha,fechaFin}=fechas
  React.useEffect(()=>{
    
  veriSesion()
   
  return ()=> {
    source.cancel();
  }
},[buscar])


  const veriSesion =  () => 
  {            
    const usu= localStorage.getItem('UsuarioNom');
    const nvl= localStorage.getItem('Tipo');	
    const usuID = localStorage.getItem("UsuId");
    if(usu==null)
    {                                
      guardarUsuario([])						
      guardarGenerales([])     
      localStorage.clear();           
      history.push("/")	
    }
    else
    {	
      if (usuario.length==0) 
      {
        guardarUsuario({Nombre:usu,nivel:nvl});                                      
      }
      guardarGenerales({Titulo:'Reporte Arranque'})                     
      getListArranque(usuID);
    }
  }

  async function getListArranque(usuID) {
    const fInicio = moment(auxFecha).format("YYYY-MM-DD");
    const fecFinal = moment(fechaFin).format("YYYY-MM-DD");            
    const data = qs.stringify({      
      Usuario: usuID,
      Reporte:1,
      Terminal:1,
      FIni:fInicio + "T00:00:00",
      FFin: fecFinal + "T23:59:59",      
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/bitacora/arranque/reporte/filtro";

    function respuesta(aux) {
      if (aux[0].length !== 0) {
        setDatos(aux[0]);
      }
    }
    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);    
  }

  function verificaReporte(auxJson) {
    let auxValido = false;
    if (auxJson.ordenes) {
      auxValido = true;
      console.log("no esta vacio");
    } else {
      auxValido = false;
      console.log("si esta vacio");
    }
    return auxValido;
  }

  const guardarFin = (auxF) => {
    setFechas({
      ...fechas,
      fechaFin: auxF,
    });
  };

  const guardarInicio = (auxF) => {
    setFechas({
      ...fechas,
      auxFecha: auxF,
    });
  };

  const incrementarBuscar = e =>
  { 
    setBuscar(!buscar)        
  };

  return (
  <div>            
    <Box display="flex" flexDirection="row">
      <Box display="flex" width="15%" flexDirection="column">                    
        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
          <Box component="span" pb={1}>
            <Tooltip title="Seleccionar Fecha Inicial">
              <Box ml={1} component="span">
                <DatePicker
                  disableFuture
                  format="dd/MM/yyyy" size="small"
                  views={["year", "month", "date"]}
                  label="Fecha Inicial" minDate="2021-07-14"
                  maxDate={new Date()} value={auxFecha}
                  onChange={guardarInicio} style={{ width: 7 + "rem" }}
                  cancelLabel={"Cancelar"} okLabel="Seleccionar"       
                />
              </Box>
            </Tooltip>
          </Box>
          <Box component="span" pb={1}>
            <Tooltip title="Seleccionar Fecha Final">
              <Box ml={1} component="span">
                <DatePicker
                  disableFuture
                  format="dd/MM/yyyy" size="small"
                  views={["year", "month", "date"]}
                  label="Fecha Final" minDate={auxFecha}
                  maxDate={new Date()} value={fechaFin}
                  onChange={guardarFin} style={{ width: 7 + "rem" }}
                  cancelLabel={"Cancelar"} okLabel="Seleccionar"       
                />
              </Box>
            </Tooltip>
          </Box>
        </MuiPickersUtilsProvider>     
 
        <Tooltip title="Buscar reporte" >  
          <Box width={{width:4+'rem'}} display="flex" justifyContent="center">                 
          <IconButton color="inherit"  aria-label="add circle" 
            component="span" onClick={incrementarBuscar} 
          >
            <SearchIcon color="primary" style={{ fontSize: 40 }}  />
          </IconButton>  
          </Box>
        </Tooltip>     
      </Box>
      
    { 
    !espera ? 
      datos.length !== 0 ?
        <Reporte urlReport={"reports/Formato-Reporte-Arranque250508.mrt"} informacion={datos}
          nombre={' Reporte Arranque'} mostrarTB={true}
        />
        :<span>{<ReporteSN urlReport={"reports/Formato-Reporte-Arranque250508.mrt"} informacion={datos}
          nombre={' Reporte Arranque'} mostrarTB={true}
        /> } </span>
        
      :
      <Box style={{width:'100%'}} pt={2}>
        <LinearProgress color="primary" /> 
      </Box>
      }                
      
    </Box>                        
  </div>
  )
}

export default RepoArranque